import {api} from "../api";
import {
    MCatChatAuthResponse,
    MCatChatEndTrackingRequest, MCatChatEndTrackingResponse, MCatChatFeedbackRequest, MCatChatFeedbackResponse,
    MCatChatStartTrackingRequest, MCatChatStartTrackingResponse
} from "./types";
import {setMcatChatAuthInfo, setShowMcatChatErrorModal} from "../../state/reducers/AuthSlice";

export const mcatChatExternal = api.injectEndpoints({
    endpoints: (builder) => ({
        authenticateUser: builder.mutation<MCatChatAuthResponse, any>({
            query: (body) => ({
                url: "/AiChat/Authenticate",
                body: {...body},
                method: "POST",
            }),
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    const { data: {jwtAccessToken} } = await queryFulfilled;
                    dispatch(setMcatChatAuthInfo({ mcatChatToken: jwtAccessToken }));
                } catch (error) {
                    dispatch(setMcatChatAuthInfo({ isMcatChatSessionEnd: true }));
                    dispatch(setShowMcatChatErrorModal(true));
                }
            },
        }),
        trackChatStart: builder.mutation<MCatChatStartTrackingRequest, MCatChatStartTrackingResponse>({
            query: (body) => ({
                url: "/AiChat/StartChat",
                body: body,
                method: "POST",
            }),
        }),
        trackChatEnd: builder.mutation<MCatChatEndTrackingRequest, MCatChatEndTrackingResponse>({
            query: (body) => ({
                url: "/AiChat/EndChat",
                body: body,
                method: "POST",
            }),
        }),
        provideFeedback: builder.mutation<MCatChatFeedbackRequest, MCatChatFeedbackResponse>({
            query: (body) => ({
                url: "/AiChat/AddFeedback",
                body: body,
                method: "POST",
            }),
        }),
    })
})

export const {
    useAuthenticateUserMutation,
    useTrackChatStartMutation,
    useTrackChatEndMutation,
    useProvideFeedbackMutation
} = mcatChatExternal;